import React from 'react'
import styled from 'styled-components'
import Box from 'shared/components/Box'
import NoteItem from 'shared/components/Notes/components/NoteItem'
import { NoteTypeWithStatus } from 'shared/components/Notes/models/note'

type NoteListProps = {
  notes: NoteTypeWithStatus[]
  user_id: string
  className?: string
  showAvatar?: boolean
  hasRowBtn?: boolean
  rowBtnTitle?: string
  onClickRowBtn?: (row: any) => void
}

function NoteList(props: NoteListProps) {
  const {
    notes,
    user_id,
    className = '',
    showAvatar = true,
    hasRowBtn = false,
    rowBtnTitle = '',
    onClickRowBtn = () => {},
  } = props

  return (
    <NoteListWrapper className={className}>
      {notes.map((each: NoteTypeWithStatus) => (
        <NoteItem
          note={each}
          showAvatar={showAvatar}
          hasRowBtn={hasRowBtn}
          rowBtnTitle={rowBtnTitle}
          onClickRowBtn={onClickRowBtn}
          user_id={user_id}
          key={`note-item-${each.id}`}
        ></NoteItem>
      ))}
    </NoteListWrapper>
  )
}

const NoteListWrapper = styled(Box)``

export default NoteList
